export default "__VITE_ASSET__BlNEkScI__"